import admin from '../apis/auth.api';
import auth from '../apis/auth.api';
import { CompanySettings } from '../types';
import { AxiosResponse } from 'axios';

const baseEndpoint = '/settings';

export const getCompanySettingsService = (): Promise<
	AxiosResponse<CompanySettings>
> => admin.get(`${baseEndpoint}`);

export const getCompanies = (): Promise<
	AxiosResponse<{ companySettings: CompanySettings[] }>
> => auth.get('/settings/user');
